/* Where the public demo is set.
   A plant owner in Houston watching trucks drive Wollongong streets is a much weaker
   pitch than watching them drive his own. We pick the city from the browser's timezone:
   instant, no permission prompt, no third-party lookup to rate-limit or fall over.
   Suburb names and haul directions are hand-written per city so it reads as real. */

// d = rough [lat, lng] offset from the city centre. Map pins are unlabelled, so these
// only need to put the run in a believable direction and distance.
const CITIES = {
  illawarra: {
    label: "Illawarra", center: [-34.4735, 150.848], plant: [-34.4561, 150.8486], plantSuburb: "Unanderra",
    sites: [
      { name: "Kembla Grange", d: [-0.0245, -0.0303] },
      { name: "Albion Park", d: [-0.0928, -0.0699] },
      { name: "Figtree", d: [0.0331, 0.0147] },
      { name: "Port Kembla", d: [-0.0027, 0.0508] },
      { name: "Corrimal", d: [0.0973, 0.0541] },
    ],
  },
  austin: {
    imperial: true,
    label: "Austin", center: [30.2672, -97.7431], plant: [30.2183, -97.7075], plantSuburb: "Montopolis",
    sites: [
      { name: "Round Rock", d: [0.2400, 0.0400] }, { name: "Pflugerville", d: [0.1700, 0.1100] },
      { name: "Del Valle", d: [-0.0800, 0.0900] }, { name: "Buda", d: [-0.1700, -0.0900] },
      { name: "Cedar Park", d: [0.2300, -0.1500] },
    ],
  },
  dallas: {
    imperial: true,
    label: "Dallas", center: [32.7767, -96.797], plant: [32.7300, -96.8500], plantSuburb: "Oak Cliff",
    sites: [
      { name: "Garland", d: [0.1400, 0.1700] }, { name: "Irving", d: [0.0600, -0.1700] },
      { name: "Mesquite", d: [-0.0100, 0.1900] }, { name: "DeSoto", d: [-0.1800, -0.0700] },
      { name: "Carrollton", d: [0.2000, -0.0900] },
    ],
  },
  houston: {
    imperial: true,
    label: "Houston", center: [29.7604, -95.3698], plant: [29.7100, -95.2800], plantSuburb: "Pasadena",
    sites: [
      { name: "Katy", d: [0.0100, -0.4000] }, { name: "Humble", d: [0.2200, 0.1000] },
      { name: "Sugar Land", d: [-0.1400, -0.2700] }, { name: "Baytown", d: [0.0100, 0.3500] },
      { name: "Pearland", d: [-0.2000, -0.0300] },
    ],
  },
  phoenix: {
    imperial: true,
    label: "Phoenix", center: [33.4484, -112.074], plant: [33.4100, -112.0200], plantSuburb: "South Phoenix",
    sites: [
      { name: "Mesa", d: [-0.0100, 0.2900] }, { name: "Tempe", d: [-0.0300, 0.1300] },
      { name: "Glendale", d: [0.1000, -0.1300] }, { name: "Chandler", d: [-0.1400, 0.2000] },
      { name: "Peoria", d: [0.1900, -0.1800] },
    ],
  },
  atlanta: {
    imperial: true,
    label: "Atlanta", center: [33.749, -84.388], plant: [33.7100, -84.4200], plantSuburb: "Lakewood",
    sites: [
      { name: "Marietta", d: [0.1900, -0.1500] }, { name: "Decatur", d: [0.0220, 0.0900] },
      { name: "Smyrna", d: [0.1400, -0.1100] }, { name: "Lawrenceville", d: [0.2100, 0.3000] },
      { name: "College Park", d: [-0.0900, -0.0500] },
    ],
  },
  losangeles: {
    imperial: true,
    label: "Los Angeles", center: [34.0522, -118.2437], plant: [33.9900, -118.2200], plantSuburb: "Vernon",
    sites: [
      { name: "Pomona", d: [0.0100, 0.4900] }, { name: "Norwalk", d: [-0.1500, 0.1600] },
      { name: "Burbank", d: [0.1300, -0.0600] }, { name: "Torrance", d: [-0.2200, -0.0900] },
      { name: "Anaheim", d: [-0.2200, 0.3300] },
    ],
  },
  chicago: {
    imperial: true,
    label: "Chicago", center: [41.8781, -87.6298], plant: [41.8200, -87.6700], plantSuburb: "McKinley Park",
    sites: [
      { name: "Cicero", d: [0.0600, -0.1300] }, { name: "Skokie", d: [0.1600, -0.0500] },
      { name: "Oak Lawn", d: [-0.1600, -0.1200] }, { name: "Elmhurst", d: [0.0900, -0.2600] },
      { name: "Calumet City", d: [-0.2700, 0.0400] },
    ],
  },
  london: {
    label: "London", center: [51.5074, -0.1278], plant: [51.5100, 0.0300], plantSuburb: "Barking",
    sites: [
      { name: "Croydon", d: [-0.1300, -0.0300] }, { name: "Hounslow", d: [-0.0400, -0.2300] },
      { name: "Enfield", d: [0.1500, -0.0500] }, { name: "Dartford", d: [-0.0600, 0.2400] },
      { name: "Wembley", d: [0.0500, -0.1700] },
    ],
  },
  manchester: {
    label: "Manchester", center: [53.4808, -2.2426], plant: [53.4700, -2.2900], plantSuburb: "Trafford Park",
    sites: [
      { name: "Salford", d: [0.0200, -0.0500] }, { name: "Oldham", d: [0.0600, 0.1400] },
      { name: "Stockport", d: [-0.0700, 0.0800] }, { name: "Bury", d: [0.1100, 0.0100] },
      { name: "Altrincham", d: [-0.0900, -0.1000] },
    ],
  },
  dublin: {
    label: "Dublin", center: [53.3498, -6.2603], plant: [53.3300, -6.3400], plantSuburb: "Ballymount",
    sites: [
      { name: "Tallaght", d: [-0.0600, -0.1100] }, { name: "Swords", d: [0.1100, -0.0400] },
      { name: "Clondalkin", d: [-0.0200, -0.1300] }, { name: "Dún Laoghaire", d: [-0.0600, 0.1300] },
      { name: "Blanchardstown", d: [0.0400, -0.1200] },
    ],
  },
  auckland: {
    label: "Auckland", center: [-36.8485, 174.7633], plant: [-36.8900, 174.8100], plantSuburb: "Penrose",
    sites: [
      { name: "Manukau", d: [-0.1400, 0.1200] }, { name: "Henderson", d: [-0.0200, -0.1300] },
      { name: "Takapuna", d: [0.0600, 0.0200] }, { name: "Papakura", d: [-0.2200, 0.1500] },
      { name: "Onehunga", d: [-0.0800, 0.0100] },
    ],
  },
  toronto: {
    label: "Toronto", center: [43.6532, -79.3832], plant: [43.6300, -79.4500], plantSuburb: "Etobicoke",
    sites: [
      { name: "Mississauga", d: [-0.0100, -0.2500] }, { name: "Scarborough", d: [0.1100, 0.1400] },
      { name: "Brampton", d: [0.0800, -0.3800] }, { name: "Vaughan", d: [0.1700, -0.1200] },
      { name: "North York", d: [0.1200, -0.0400] },
    ],
  },
  dubai: {
    label: "Dubai", center: [25.2048, 55.2708], plant: [25.1400, 55.2300], plantSuburb: "Al Quoz",
    sites: [
      { name: "Jebel Ali", d: [-0.1600, -0.2400] }, { name: "Deira", d: [0.0700, 0.0500] },
      { name: "Mirdif", d: [0.0100, 0.1500] }, { name: "Dubai Marina", d: [-0.1100, -0.1400] },
      { name: "Sharjah", d: [0.1300, 0.1800] },
    ],
  },
  johannesburg: {
    label: "Johannesburg", center: [-26.2041, 28.0473], plant: [-26.2400, 28.0900], plantSuburb: "Germiston",
    sites: [
      { name: "Midrand", d: [0.2000, 0.0400] }, { name: "Soweto", d: [-0.0500, -0.1800] },
      { name: "Sandton", d: [0.1000, 0.0100] }, { name: "Roodepoort", d: [-0.0100, -0.1800] },
      { name: "Boksburg", d: [-0.0200, 0.1900] },
    ],
  },
};

// Timezone → the market city we've authored. Anything unrecognised stays on the
// Illawarra, which is where the software actually runs.
const TZ_MAP = {
  "America/Chicago": "dallas", "America/Indiana/Indianapolis": "chicago", "America/Detroit": "chicago",
  "America/Menominee": "chicago", "America/North_Dakota/Center": "chicago", "America/Winnipeg": "chicago",
  "America/New_York": "atlanta", "America/Toronto": "toronto", "America/Montreal": "toronto",
  "America/Los_Angeles": "losangeles", "America/Tijuana": "losangeles", "America/Vancouver": "losangeles",
  "America/Phoenix": "phoenix", "America/Denver": "phoenix", "America/Edmonton": "phoenix",
  "America/Boise": "phoenix", "America/Mexico_City": "houston", "America/Monterrey": "houston",
  "Europe/London": "london", "Europe/Belfast": "manchester", "Europe/Dublin": "dublin",
  "Europe/Isle_of_Man": "manchester", "Europe/Jersey": "london", "Europe/Guernsey": "london",
  "Pacific/Auckland": "auckland", "Pacific/Chatham": "auckland",
  "Asia/Dubai": "dubai", "Asia/Muscat": "dubai", "Asia/Qatar": "dubai", "Asia/Riyadh": "dubai",
  "Asia/Bahrain": "dubai", "Asia/Kuwait": "dubai",
  "Africa/Johannesburg": "johannesburg", "Africa/Maseru": "johannesburg", "Africa/Gaborone": "johannesburg",
  "Africa/Harare": "johannesburg", "Africa/Lusaka": "johannesburg", "Africa/Windhoek": "johannesburg",
};

// A few US states share America/Chicago — nudge Texans to a Texas city using the locale
// region when the browser gives us one.
const TX_HINTS = ["austin", "houston", "dallas"];

function pick() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    let key = TZ_MAP[tz];
    if (!key && tz.startsWith("Australia/")) key = "illawarra";
    if (key === "dallas") {
      // Spread the central-US visitors across the Texas cities we've authored so it isn't
      // always Dallas; the timezone can't tell us which of them it is.
      const n = Math.abs((tz + (navigator.language || "")).split("").reduce((a, c) => a + c.charCodeAt(0), 0));
      key = TX_HINTS[n % TX_HINTS.length];
    }
    return CITIES[key] || CITIES.illawarra;
  } catch {
    return CITIES.illawarra;
  }
}

export const CITY = pick();
/** Only the US market batches in yards and PSI; everywhere else we author is metric. */
export const IMPERIAL = !!CITY.imperial;
export const SITES = CITY.sites.map((s) => ({
  ...s,
  latlng: [CITY.center[0] + s.d[0], CITY.center[1] + s.d[1]],
}));
/** A believable haul corridor: plant → a bent midpoint → the site. */
export const routeTo = (site) => {
  const [pLat, pLng] = CITY.plant;
  const [sLat, sLng] = site.latlng;
  const mLat = (pLat + sLat) / 2 + (sLng - pLng) * 0.08;
  const mLng = (pLng + sLng) / 2 - (sLat - pLat) * 0.08;
  return [CITY.plant, [mLat, mLng], site.latlng];
};
